import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("asap_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 p-8" data-testid="admin-login-form">
        <p className="font-outfit font-semibold text-slate-900 text-lg">
          ASAP <span className="text-sky-500">Glass</span> &amp; Aluminium
        </p>
        <p className="mt-1 text-sm text-slate-500">Admin sign in</p>
        <div className="mt-8">
          <Label htmlFor="admin-email" className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Email</Label>
          <Input id="admin-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-sm" />
        </div>
        <div className="mt-5">
          <Label htmlFor="admin-password" className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Password</Label>
          <Input id="admin-password" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-sm" />
        </div>
        <Button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="mt-8 w-full bg-slate-900 hover:bg-sky-500 rounded-sm transition-colors duration-300">
          {loading ? "Signing in…" : "Sign In"}
        </Button>
        <a href="/" data-testid="admin-back-home-link" className="mt-6 block text-center text-xs text-slate-400 hover:text-slate-600 transition-colors duration-200">
          Back to website
        </a>
      </form>
    </div>
  );
}
